// A file with `externalOwnerSystem = 'desktop'` is MIRRORED here, not kept here: the orgaMAX
// Desktop installation stays its source of truth. The API therefore accepts exactly two fields for
// such a file — `notes` and `tags` (api/src/services/fileService/update.js, `allowedKeys`) — and
// answers anything else with ValidationError{ externalOwnerSystem: NOT_ALLOWED }, which the list
// duck turns into `lang.documents.erpEditError`.
//
// Two details of that server rule decide how the client has to behave:
//
//  - it rejects on the mere PRESENCE of a key, not on a changed value. The drawer posts the WHOLE
//    document, so an edited note was refused together with the untouched `name` and `metaData`
//    riding along — nothing at all could be saved on a desktop document.
//  - `tags` includes the system tag, i.e. the „Art". A reclassification therefore travels with the
//    tags and stays possible on a desktop document, while the field it does NOT reach is
//    documentInvoiceDetails: an Art change that would otherwise close an open review
//    (review-art-change.ts) cannot do so here, because that key would have the server refuse the
//    whole save.
import { EXTERNAL_OWNER_SYSTEMS } from '@/modules/file/external-owner-systems'

// Mirrors `allowedKeys` in api/src/services/fileService/update.js. Anything outside this list is
// read-only on a desktop-owned file.
export const DESKTOP_EDITABLE_FILE_FIELDS = ['notes', 'tags']

export const isDesktopOwnedFile = file =>
  file?.externalOwnerSystem === EXTERNAL_OWNER_SYSTEMS.desktop

/**
 * The only payload a desktop-owned file may be saved with. `id` travels because FileService builds
 * the request URL from it — it is not part of the body.
 */
export const pickDesktopEditableFileFields = (file) => {
  const payload: Record<string, unknown> = { id: file?.id }

  for (const key of DESKTOP_EDITABLE_FILE_FIELDS) {
    if (file && key in file) {
      payload[key] = file[key]
    }
  }

  return payload
}
